import { render, staticRenderFns } from "./Matters.vue?vue&type=template&id=5321d54c"
import script from "./Matters.vue?vue&type=script&lang=js"
export * from "./Matters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports